import { render } from "./customer_data.html?vue&type=template&id=3b34fafd&scoped=true&external"
import script from "./customer_data.js?vue&type=script&lang=js&external"
export * from "./customer_data.js?vue&type=script&lang=js&external"

import "./CustomerData.vue?vue&type=style&index=0&id=3b34fafd&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b34fafd"]])

export default __exports__